<template>
    <div class="fhv-centent" v-loading="showLoading" >
        <h4 class="title-topic">WPS setting</h4>
          <el-form :model="wpsSettingForm" 
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            ref="wpsSettingForm"
            >
            <el-form-item label="WLAN" prop="type">
                <el-select v-model="wpsSettingForm.protocol" placeholder="Please select" style="width: 100%">
                    <el-option label="All" value="0"></el-option>
                    <el-option label="2.4G" value="1"></el-option>
                    <el-option label="5G" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="WPS key configuration">
                <el-button type="primary" @click="startConfig">Start configuration</el-button>
                <el-button type="primary" @click="stopConfig">Stop configuration</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
import devConfig from '@/devConfig'
export default {
    data() {
        return {
            showLoading: false,
            wl1Enable:true,//2.4G enable
            wl0Enable:true, //5G enable
            wpsSettingForm:{
                protocol:"0"   // 0 all    1 2.4G    2  5G
            },
        }
    },
    created(){
         devConfig.init(this,()=>{
            this.getBasicData1(); //2.4G
            this.getBasicData2(); //5G
        })
    },
    methods: {
        startConfig() {
            
            if(this.wl1Enable===false && this.wpsSettingForm.protocol==="1"){
                this.$message.error("2.4G Wi-Fi has been closed，Please go to Wi-Fi configuration page to open 2.4G Wi-Fi.");
                return false
            }else if(this.wl0Enable===false && this.wpsSettingForm.protocol==="2"){
                this.$message.error("5G Wi-Fi has been closed,Please go to Wi-Fi configuration page to open 5G Wi-Fi.");
                return false
            }else if(this.wpsSettingForm.protocol==="0" && (this.wl1Enable===false || this.wl0Enable===false)){
                this.$message.error("Wi-Fi has been closed,Please go to Wi-Fi configuration page to open Wi-Fi.");
                return false
            }
            this.showLoading = true;
            let param = {
                protocol:this.wpsSettingForm.protocol,
                configType:0  //0 start  1cancel
            };
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WPS_CONFIG",
                protocol:this.wpsSettingForm.protocol,
                configType:"0"
            })
            .then((response)=>{               
                if(response.data.ret === 0){ 
                    setTimeout(()=>{
                        this.showLoading = false   
                        this.$message.success("WPS pairing begins,please connect within 2 minutes")
                    },2000)
                }              
            })
        },
        stopConfig(){
            this.showLoading = true;
            let param = {
                protocol:this.wpsSettingForm.protocol,
                configType:"1"  //0 start  1cancel
            };
            axios
            .post("/JSONAPI",{
                    cmdType:"SET_WPS_CONFIG",
                    protocol:this.wpsSettingForm.protocol,
                    configType:"1"
                })
            .then((response)=>{         
                if(response.data.ret === 0){
                    setTimeout(()=>{
                        this.showLoading = false   
                        this.$message.success("WPS pairing stops successful!")
                    },2000)    
                }              
            })
        },
        getBasicData1(){
            this.showLoading = true;
            axios
            .post("/boafrm/fhBasicWlan",{
                CmdType:"GET_BASE_WLAN",
                ssidIndex:"0"
            })
            .then((response)=>{
                this.showLoading = false;
                if(response.data.ret == '0')
                {
                    this.wl1Enable = response.data.allEnable 
                }
            })
        },
        getBasicData2(){
            this.showLoading = true;
            axios
            .post("/boafrm/fhBasicWlan",{
                CmdType:"GET_BASE_WLAN",
                ssidIndex:"4"
            })
            .then((response)=>{
                this.showLoading = false;
                if(response.data.ret == '0')
                {
                    this.wl0Enable = response.data.allEnable 
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
.time {
  color: #737373;
  float: left;
}
textarea {
  resize: none;
  width: 100%;
  height: 200px;
}
.panel-heading {
  color: #333;
  background-color: #f5f5f5;
  border-color: #ddd;
  padding: 10px 15px;
  border-bottom: 1px solid transparent;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}
.textb {
  padding: 15px;
}
</style>





